import React, { useState } from "react";
import {
  Container,
  Title,
  Group,
  Button,
  TextInput,
  Tabs,
  SimpleGrid,
  Loader,
  Center,
} from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { IconPlus, IconSearch } from "@tabler/icons-react";
import { bridgeService } from "../../../services/bridgeService";
import {
  WorkstationStatusCard,
  RegisterWorkstationModal,
} from "../../../components/bridge";
import { useBridgeStatus } from "../../../hooks/useBridgeStatus";

const BridgeWorkstationList: React.FC = () => {
  const [statusFilter, setStatusFilter] = useState<string | null>("all");
  const [search, setSearch] = useState("");
  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  useBridgeStatus(); // Enable real-time updates

  const { data, isLoading } = useQuery({
    queryKey: ["bridge-workstations", statusFilter],
    queryFn: () =>
      bridgeService.getWorkstations({
        status: statusFilter === "all" ? undefined : statusFilter || undefined,
        limit: 100,
      }),
    select: (res) => res.data,
  });

  const workstations = (data?.data || []).filter(
    (ws) => !search || ws.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Title order={2}>Device Management</Title>
        <Button
          leftSection={<IconPlus size={16} />}
          onClick={() => setRegisterModalOpen(true)}
        >
          Register Workstation
        </Button>
      </Group>

      <Group mb="md">
        <TextInput
          placeholder="Search workstations..."
          leftSection={<IconSearch size={16} />}
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value)}
          style={{ flex: 1 }}
        />
      </Group>

      <Tabs value={statusFilter} onChange={setStatusFilter} mb="md">
        <Tabs.List>
          <Tabs.Tab value="all">All</Tabs.Tab>
          <Tabs.Tab value="online">Online</Tabs.Tab>
          <Tabs.Tab value="offline">Offline</Tabs.Tab>
        </Tabs.List>
      </Tabs>

      {isLoading ? (
        <Center py="xl">
          <Loader />
        </Center>
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          {workstations.map((ws) => (
            <WorkstationStatusCard key={ws.id} workstation={ws} />
          ))}
        </SimpleGrid>
      )}

      <RegisterWorkstationModal
        opened={registerModalOpen}
        onClose={() => setRegisterModalOpen(false)}
      />
    </Container>
  );
};

export default BridgeWorkstationList;
